import { InfiniteData, QueryClient } from '@tanstack/react-query';

/**
 * Largest number of pages cached across every query-key variant under `queryKey`
 * (different filter combinations each hold their own infinite-query cache entry).
 * Used to decide whether a list refresh should be silent (≤1 page) or banner-gated.
 */
export const getMaxLoadedPages = (queryClient: QueryClient, queryKey: unknown[]): number => {
  const cachedQueries = queryClient.getQueriesData<InfiniteData<unknown>>({ queryKey });
  return cachedQueries.reduce((max, [, cached]) => {
    const pages = (cached as InfiniteData<unknown> | undefined)?.pages;
    return Math.max(max, pages?.length ?? 0);
  }, 0);
};
